export default __webpack_public_path__ + "static/media/humidity.38d0c2ff.svg";